import PropTypes from "prop-types"
import React from "react"

import { withTranslation } from "../../../i18n/translate"
import ListIcon from "../../../images/icons/list.svg"
import PrintIcon from "../../../images/icons/print.svg"
import TableIcon from "../../../images/icons/table.svg"
import Button from "../../button/button"
import ButtonGroup from "../../button/button-group"
import Tile from "../../tile/tile"
import ProductList from "../product-list/product-list"
import ProductTable from "../product-table/product-table"
import ProductTablePrintModal from "./product-table-print-modal";
import {isMobileOrTablet} from "../../../util/browser-type";

class ProductTableList extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      useTable: false,
      print: false,
      isMobileBrowser: true,
    }
  }

  componentDidMount() {
    if (!isMobileOrTablet()) {
      this.setState({isMobileBrowser: false})
    }
  }

  render() {
    const { useTable, print } = this.state
    const { db, productParamGroups } = this.props

    const { t } = this.props

    return (
      <div>
        {print && <ProductTablePrintModal productsDatabase={db} productParamGroups={productParamGroups} path={this.props.path}
                                 onClose={() => this.setState({print: false})}/>}

        <div className="_fp-product-view__actions">
          <ButtonGroup labelTranslationKey={"PRODUCTS-VIEW_COLON"}>
            <Button
              buttonStyle={
                this.state.useTable && db.getFilteredProducts().length > 0
                  ? "green"
                  : "disabled"
              }
              buttonSvgIconComponent={<ListIcon />}
              buttonCallback={() => this.setState({ useTable: false })}
            />
            <Button
              buttonStyle={
                !this.state.useTable && db.getFilteredProducts().length > 0
                  ? "green"
                  : "disabled"
              }
              buttonSvgIconComponent={<TableIcon />}
              buttonCallback={() => this.setState({ useTable: true })}
            />
          </ButtonGroup>

          <span style={{ display: "flex", alignItems: "center" }}>
            <div className="_fp-product-view__count">
              {t("PRODUCTS-RESULTS_COUNT", {
                postProcess: "interval",
                count: db.getFilteredProducts().length,
              })}
            </div>
            {!this.state.isMobileBrowser && <Button
                buttonLabel={t("GLOBAL-PRINT")}
                buttonSvgIconComponent={<PrintIcon/>}
                buttonCallback={() => {
                  this.setState({print: true})
                }}
                buttonStyle={
                  db.getFilteredProducts().length > 0 ? "green" : "disabled"
                }
            />}
          </span>
        </div>

        {db.getFilteredProducts().length === 0 && (
          <Tile
            titleTranslatedString={t(
              "PRODUCTS-PRODUCT_LIST-NO_PRODUCTS_FOUND-TITLE",
            )}
          >
            {t("PRODUCTS-PRODUCT_LIST-NO_PRODUCTS_FOUND-DESCRIPTION")}
          </Tile>
        )}

        {!useTable && (
          <ProductList
            filterKey={this.props.filterKey}
            productsDatabase={db}
            productParamGroups={productParamGroups}
          />
        )}

        {useTable && (
          <ProductTable
            filterKey={this.props.filterKey}
            productsDatabase={db}
            productParamGroups={productParamGroups}
          />
        )}
      </div>
    )
  }
}

ProductTableList.propTypes = {
  productParamGroups: PropTypes.any,
  db: PropTypes.any,
  filterKey: PropTypes.string,
  path: PropTypes.string.isRequired,
}

export default withTranslation()(ProductTableList)
